export const foundUsOptions = [
	{ "label":"Veterinarian", "value": "veterinarian" },
	{ "label":"Friend or Family", "value": "friend" },
	{ "label":"Emergency Clinic", "value": "emergencyClinic"},
	{ "label":"Google", "value": "googleSearch" },
	{ "label":"Social Media", "value": "socialMedia" },
	{ "label":"App Store", "value": "appStore" },
	{ "label":"Other", "value": "other" },
];
